import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { apiGet } from '../api';
import type { InvestorMe } from '../types';
import { useAsync } from './useAsync';

export function useInvestorMe(opts?: { enforceNda?: boolean }) {
  const nav = useNavigate();
  const loc = useLocation();
  const { data, error, loading, setData } = useAsync<InvestorMe>(() => apiGet('/api/investor/me'), []);

  useEffect(() => {
    if (!opts?.enforceNda) return;
    if (loading) return;
    if (!data) return;
    if (data.needsNda && !loc.pathname.endsWith('/nda')) {
      nav('/app/nda', { replace: true });
    }
  }, [data, loading, nav, loc.pathname, opts?.enforceNda]);

  return { me: data, error, loading, setMe: setData };
}

